import axios from "axios";
import BASE_URL from "./index";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

export const getAllDeliverableOptions = async (data) => {
  try {
    const res = await axios.get(BASE_URL + "/deliverableOptions/getAll", {
      Headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data[0];
  } catch (error) {}
};

// Errors are not swallowed: this used to catch and discard every failure, so
// a rejected save looked exactly like a successful one to the screen.
export const updateAllDeliverableOptions = async (data) => {
  return axios.post(BASE_URL + "/deliverableOptions/updateAll", { data });
};
